<script>
    import { nanoid } from "nanoid";

    export let id = nanoid(6);
    export let disabled = null;
</script>

{#if !disabled}
    <form novalidate autocomplete="off" {id} method="post" on:submit|preventDefault>
        <slot></slot>
    </form>
{:else}
    <slot></slot>
{/if}
